// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"4b38b49e","488":"e532776c"}[chunkId] + ".chunk.js";
};